/* eslint-disable no-useless-catch */
import get from 'lodash/get';
import {
  BusinessLevels,
  EinvoicePage,
  EinvoiceSummaryDTO,
  PageMetaInfo,
} from '../common/types';
import { appConfig } from '../config/app-config';
import { API_END_POINTS } from '../config/api-endpoints';
import { InvoiceRequestBody } from './common/types';
import {
  createOrUpdateInvoiceSummary,
  getInvoicesSummaryFromDb,
} from '../db/invoices-summary-db';
import { callApi } from "../common/api";

const getResponseFromApi = async (
  invoiceStartDate: string,
  invoiceEndDate: string,
  businessLevel: BusinessLevels,
  business: string,
  orgId: string,
  pageNumber: number,
  businessId: string,
): Promise<EinvoicePage> => {
  const data: InvoiceRequestBody = {
    filter: {
      invoiceStartDate,
      invoiceEndDate,
    },
    pageMetaData: {
      PageNumber: pageNumber,
      PageSize: appConfig.INVOICE_SUMMARY_PAGE_SIZE as number,
    },
  };

  let headers: any = {
    'Content-Type': 'application/json',
    'node-id': businessId,
    'node-type': businessLevel,
  };

  switch (businessLevel) {
    case BusinessLevels.PAN:
      headers = {
        ...headers,
        PAN: business,
      };
      break;
    case BusinessLevels.GSTIN:
      headers = {
        ...headers,
        GSTIN: business,
      };
      break;
    case BusinessLevels.BRANCH:
      headers = {
        ...headers,
        BRANCH: business,
      };
      break;
  }

  const response = await callApi({
    method: 'POST',
    url: API_END_POINTS.EINVOICE.INVOICES,
    data,
    headers,
  });

  const pageMetaInfo = get(response, 'data.pageMetaInfo') as PageMetaInfo;
  const einvoiceSummaryDtos = get(
    response,
    'data.einvoiceSummaryDTO',
    []
  ) as EinvoiceSummaryDTO[];

  createOrUpdateInvoiceSummary(einvoiceSummaryDtos, orgId);

  return {
    einvoiceSummaryDtos,
    pageMetaInfo,
  };
};

export const getInvoicesSummary = async (
  invoiceStartDate: string,
  invoiceEndDate: string,
  businessLevel: BusinessLevels,
  business: string,
  orgId: string,
  pageNumber: number,
  businessId: string
) => {
  try {
    const responseFromApi = getResponseFromApi(
      invoiceStartDate,
      invoiceEndDate,
      businessLevel,
      business,
      orgId,
      pageNumber,
      businessId,
    );

    const responseFromDb = await getInvoicesSummaryFromDb(
      orgId,
      invoiceStartDate,
      invoiceEndDate,
      pageNumber
    );

    if (responseFromDb && responseFromDb.einvoiceSummaryDtos.length !== 0) {
      // console.log('From db');
      return responseFromDb;
    }
    // console.log('From api');
    const response = await responseFromApi;
    return response;
  } catch (err) {
    // console.log(err);
    throw err;
  }
};
